/** 학습계획 활동 설정. 카테고리별로 활동명·방법·설명을 적어 둔다. */

export type LearningPlanPhase = 'intro' | 'learn' | 'wrap';

export type LearningPlanCategory = {
  id: string;
  name: string;
  sort: number;
};

export type LearningPlanActivity = {
  id: string;
  /** 카테고리 id. 기본은 intro, learn, wrap */
  phase: string;
  /** 활동명 */
  name: string;
  /** 활동 종류·구조. 메모의 괄호에 쓴다. 예: 모둠활동 · 조사활동 */
  method: string;
  /** 활동 설명 */
  guide: string;
  sort: number;
};

export const LEARNING_PLAN_BUILTIN_CATEGORIES: LearningPlanCategory[] = [
  { id: 'intro', name: '도입활동', sort: 0 },
  { id: 'learn', name: '배움활동', sort: 1 },
  { id: 'wrap', name: '정리활동', sort: 2 },
];

export function isLearningPlanBuiltinCategory(id: string): boolean {
  return id === 'intro' || id === 'learn' || id === 'wrap';
}
